import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "border p-3 mt-4" }
const _hoisted_2 = {
  key: 0,
  class: "form-group mb-4"
}
const _hoisted_3 = { class: "form-check" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "form-group mb-4" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "form-row" }
const _hoisted_9 = { class: "form-group mb-4 col" }
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "form-group mb-4 col" }
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "form-row" }
const _hoisted_16 = {
  key: 0,
  class: "form-group mb-4 col"
}
const _hoisted_17 = { class: "form-group mb-4 col" }

import { computed, shallowReactive } from 'vue'
    import { MonthYearHelpers, MonthYear } from '@common/types'
    import { MonthPickerDialogViewModel } from '@common/Components/MonthPickerDialog'
    import MonthPickerDialog from '@common/Components/MonthPickerDialog.vue'

    type CommitmentType = 'Total' | 'Committed' | 'Tentative'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MetricScheduleDependentSettings',
  props: {
    canDisable: { type: Boolean },
    isScheduleDependent: { type: Boolean },
    defaultProjectStartDate: {},
    startDateBoundary: {},
    endDateBoundary: {},
    applyBenefitsConfidenceFactor: { type: Boolean },
    valueCommitmentType: {},
    showRiskAdjustment: { type: Boolean }
  },
  emits: ["update:isScheduleDependent", "update:defaultProjectStartDate", "update:startDateBoundary", "update:endDateBoundary", "update:applyBenefitsConfidenceFactor", "update:valueCommitmentType"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    const isScheduleDependentModel = computed({
        get: () => props.isScheduleDependent,
        set: v => emit('update:isScheduleDependent', v)
    })

    const applyBenefitsConfidenceFactorModel = computed({
        get: () => props.applyBenefitsConfidenceFactor,
        set: v => emit('update:applyBenefitsConfidenceFactor', v)
    })

    const valueCommitmentTypeModel = computed({
        get: () => props.valueCommitmentType,
        set: v => emit('update:valueCommitmentType', v)
    })

    const showRiskAdjustment = computed(() => props.showRiskAdjustment ?? true)

    const startDateBoundaryLabel = computed(() => MonthYearHelpers.toMonthYearLongString(props.startDateBoundary))
    const endDateBoundaryLabel = computed(() => MonthYearHelpers.toMonthYearLongString(props.endDateBoundary))
    const defaultProjectStartDateLabel = computed(() => MonthYearHelpers.toMonthYearLongString(props.defaultProjectStartDate))

    const startDateBoundaryMonthPicker = shallowReactive(new MonthPickerDialogViewModel())
    const endDateBoundaryMonthPicker = shallowReactive(new MonthPickerDialogViewModel())
    const defaultProjectStartDateMonthPicker = shallowReactive(new MonthPickerDialogViewModel())

    // actions

    function showStartDateBoundaryMonthPicker()
    {
        startDateBoundaryMonthPicker.show(props.startDateBoundary, "Metric Start Date Boundary", false)
    }

    function showEndDateBoundaryMonthPicker()
    {
        endDateBoundaryMonthPicker.show(props.endDateBoundary, "Metric End Date Boundary", false)
    }

    function showDefaultProjectStartDateMonthPicker()
    {
        defaultProjectStartDateMonthPicker.show(props.defaultProjectStartDate, "Default Project Start Date", false)
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MonthPickerDialog, {
      viewModel: _unref(startDateBoundaryMonthPicker),
      onUpdateDate: _cache[0] || (_cache[0] = ($event: any) => (emit('update:startDateBoundary', $event)))
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(MonthPickerDialog, {
      viewModel: _unref(endDateBoundaryMonthPicker),
      onUpdateDate: _cache[1] || (_cache[1] = ($event: any) => (emit('update:endDateBoundary', $event)))
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(MonthPickerDialog, {
      viewModel: _unref(defaultProjectStartDateMonthPicker),
      onUpdateDate: _cache[2] || (_cache[2] = ($event: any) => (emit('update:defaultProjectStartDate', $event)))
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createElementVNode("fieldset", _hoisted_1, [
      _cache[22] || (_cache[22] = _createElementVNode("legend", { class: "w-auto px-2 text-primary" }, "Schedule-dependent Settings", -1 /* CACHED */)),
      _createCommentVNode(" Toggle Schedule Dependent Settings "),
      (__props.canDisable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "metricScheduleDependentToggle",
                class: "form-check-input",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isScheduleDependentModel).value = $event)),
                "data-testid": "schedule-dependent-toggle"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, isScheduleDependentModel.value]
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("label", {
                for: "metricScheduleDependentToggle",
                class: "form-check-label"
              }, " Enable schedule-dependent settings to configure time-sensitive and commitment-based metric adjustments. ", -1 /* CACHED */))
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Schedule Dependent Settings "),
      (__props.isScheduleDependent || !__props.canDisable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createCommentVNode(" Default Project Start Date "),
            _createElementVNode("div", _hoisted_5, [
              _cache[8] || (_cache[8] = _createElementVNode("label", {
                for: "metricDefaultProjectStartDate",
                class: "form-label"
              }, "Default Project Start Date:", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("input", {
                  value: defaultProjectStartDateLabel.value,
                  type: "text",
                  class: "form-control pointer bg-white",
                  placeholder: "Optional...",
                  readonly: "",
                  id: "metricDefaultProjectStartDate",
                  onClick: showDefaultProjectStartDateMonthPicker,
                  "data-testid": "default-project-start-date"
                }, null, 8 /* PROPS */, _hoisted_7),
                _createElementVNode("div", { class: "input-group-append" }, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary",
                    type: "button",
                    onClick: showDefaultProjectStartDateMonthPicker,
                    "data-testid": "default-project-start-date-button"
                  }, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("i", {
                      class: "fa-regular fa-calendar",
                      "aria-hidden": "true"
                    }, null, -1 /* CACHED */)
                  ]))])
                ])
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("small", { class: "form-text text-muted" }, [
                _createTextVNode(" Used as the default start date for projects without one. Enables schedule-dependent calculations for unscheduled projects. "),
                _createElementVNode("strong", null, "If neither a set nor default start date is provided, schedule-dependent metrics will have no value.")
              ], -1 /* CACHED */))
            ]),
            _createCommentVNode(" Metric Boundaries "),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[11] || (_cache[11] = _createElementVNode("label", {
                  for: "metricStartDateBoundary",
                  class: "form-label"
                }, "Metric Start Date Boundary:", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("input", {
                    value: startDateBoundaryLabel.value,
                    id: "metricStartDateBoundary",
                    type: "text",
                    class: "form-control pointer bg-white",
                    placeholder: "Optional...",
                    readonly: "",
                    onClick: showStartDateBoundaryMonthPicker,
                    "data-testid": "start-date-boundary"
                  }, null, 8 /* PROPS */, _hoisted_11),
                  _createElementVNode("div", { class: "input-group-append" }, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      type: "button",
                      onClick: showStartDateBoundaryMonthPicker,
                      "data-testid": "start-date-boundary-button"
                    }, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("i", {
                        class: "fa-regular fa-calendar",
                        "aria-hidden": "true"
                      }, null, -1 /* CACHED */)
                    ]))])
                  ])
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("small", { class: "form-text text-muted" }, " Includes only values after this date in calculations. If not set, values start from the project’s start date. ", -1 /* CACHED */))
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[14] || (_cache[14] = _createElementVNode("label", {
                  for: "metricEndDateBoundary",
                  class: "form-label"
                }, "Metric End Date Boundary:", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("input", {
                    value: endDateBoundaryLabel.value,
                    id: "metricEndDateBoundary",
                    type: "text",
                    class: "form-control pointer bg-white",
                    placeholder: "Optional...",
                    readonly: "",
                    onClick: showEndDateBoundaryMonthPicker,
                    "data-testid": "end-date-boundary"
                  }, null, 8 /* PROPS */, _hoisted_14),
                  _createElementVNode("div", { class: "input-group-append" }, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      type: "button",
                      onClick: showEndDateBoundaryMonthPicker,
                      "data-testid": "end-date-boundary-button"
                    }, [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("i", {
                        class: "fa-regular fa-calendar",
                        "aria-hidden": "true"
                      }, null, -1 /* CACHED */)
                    ]))])
                  ])
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("small", { class: "form-text text-muted" }, " Includes only values before this date in calculations. If not set, values include all up to the project’s end date. ", -1 /* CACHED */))
              ])
            ]),
            _createCommentVNode(" Risk Adjustment "),
            _createElementVNode("div", _hoisted_15, [
              (showRiskAdjustment.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", {
                      for: "metricApplyBenefitsConfidenceFactor",
                      class: "form-label"
                    }, "Risk Adjustment:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("select", {
                      id: "metricApplyBenefitsConfidenceFactor",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((applyBenefitsConfidenceFactorModel).value = $event)),
                      "data-testid": "risk-adjustment"
                    }, [...(_cache[16] || (_cache[16] = [
                      _createElementVNode("option", { value: false }, "Disabled", -1 /* CACHED */),
                      _createElementVNode("option", { value: true }, "Enabled", -1 /* CACHED */)
                    ]))], 512 /* NEED_PATCH */), [
                      [_vModelSelect, applyBenefitsConfidenceFactorModel.value]
                    ]),
                    _cache[18] || (_cache[18] = _createElementVNode("small", { class: "form-text text-muted" }, " Applies a risk factor to adjust the metric value after the Benefits Confidence Date set at the portfolio level. This setting is applicable only if the value source includes savings (benefits). ", -1 /* CACHED */))
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" Commitment Adjustment "),
              _createElementVNode("div", _hoisted_17, [
                _cache[20] || (_cache[20] = _createElementVNode("label", {
                  for: "metricValueCommitmentType",
                  class: "form-label"
                }, "Commitment Adjustment:", -1 /* CACHED */)),
                _withDirectives(_createElementVNode("select", {
                  id: "metricValueCommitmentType",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((valueCommitmentTypeModel).value = $event)),
                  "data-testid": "commitment-adjustment"
                }, [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("option", { value: "Total" }, "Disabled", -1 /* CACHED */),
                  _createElementVNode("option", { value: "Committed" }, "Committed", -1 /* CACHED */),
                  _createElementVNode("option", { value: "Tentative" }, "Tentative", -1 /* CACHED */)
                ]))], 512 /* NEED_PATCH */), [
                  [_vModelSelect, valueCommitmentTypeModel.value]
                ]),
                _cache[21] || (_cache[21] = _createElementVNode("small", { class: "form-text text-muted" }, [
                  _createTextVNode(" Adjusts the metric value based on the project commitment date: "),
                  _createElementVNode("strong", null, "Committed:"),
                  _createTextVNode(" Includes values before the commitment date, reflecting firmly committed values. "),
                  _createElementVNode("strong", null, "Tentative:"),
                  _createTextVNode(" Includes values after the commitment date, reflecting flexible or changeable plans. "),
                  _createElementVNode("strong", null, "Disabled:"),
                  _createTextVNode(" Ignores the commitment date, including all values. "),
                  _createElementVNode("strong", null, "Note:"),
                  _createTextVNode(" If no commitment date is set, all values are considered tentative. ")
                ], -1 /* CACHED */))
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})